<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('RailwayExport.SellingContainer')"
    width="1000px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div class="app-main-row">
      <el-form class="input-w240" :inline="true" label-width="75px" label-position="right">
        <el-form-item :label="$t('RailwayExport.OrderNo2')+':'">
          <el-input v-model="order.orderNo" :disabled="true" no="orderNo" style="width: 200px;margin-left: 40px;" />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.Buyer2')+':'" style="margin-left: 40px;">
          <cargo-advance-select
            no="buyerId"
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{active:true}"
            filterable
            :default-value="order.buyerId||''"
            style="width: 200px;margin-left: 40px;"
            @parentCallBack="p=>{order.buyerId=p.value}"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="app-main-row">
      <el-form class="input-w240" :inline="true" label-width="75px" label-position="right">
        <el-form-item :label="$t('RailwayExport.SellerDate')+':'">
          <el-date-picker
            v-model="order.sellerDate"
            no="sellerDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 200px;margin-left: 40px;"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.SettlingTime')+':'" style="margin-left: 40px;">
          <el-date-picker
            v-model="order.settlementDate"
            no="settlementDate"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            style="width: 200px;margin-left: 40px;"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="app-main-row">
      <div style="width: 680px;display: flex;">
        <div style="width: 325px;">
          <div style="margin-left: 11px;">
            {{ $t('RailwayExport.TotalPurchaseContainer') }}
            <span style="margin-left: 10px;">{{ buyLabel }}</span>
          </div>
        </div>
        <div style="width: 30px;" />
        <div style="width: 325px;">
          <div style="margin-left: 10px;">
            {{ $t('RailwayExport.TotalCostAmount') }}
            <span style="margin-left: 10px;">{{ buyAmountLabel }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="app-main-row" style="margin: 5px 0;border-bottom: 1px solid #adaeb1;" />
    <div class="app-main-row" style="display: flex;margin-bottom: 6px;">
      <div style="width: 680px;display: flex;">
        <div style="width: 325px;">
          <div style="margin-left: 11px;">
            {{ $t('RailwayExport.TotalSoldContainer') }}
            <span style="margin-left: 10px;">{{ sellLabel }}</span>
          </div>
        </div>
        <div style="width: 30px;" />
        <div style="width: 325px;">
          <div style="margin-left: 10px;">
            {{ $t('RailwayExport.TotalSellingAmount') }}
            <span style="margin-left: 10px;">{{ sellAmountLabel }}</span>
          </div>
        </div>
      </div>
      {{ $t('RailwayExport.WhetherSettlement') }}：
      <el-select v-model="order.ifSettlement" no="ifSettlement" style="width: 180px;">
        <el-option v-for="(item,index) in JUDGE_STATUS" :key="index" :label="item.chineseName" :value="item.code" />
      </el-select>
    </div>
    <div class="app-main-row">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;height: 300px"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <span slot="footer">
      <el-button no="Confirm" type="primary" @click="successHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
    <!-- 组件样式模板（用于嵌入ag-grid）-->
    <div v-show="false">
      <el-button ref="deleteBtnTemplate" type="primary" no="1" onclick="void(0)">{{ $t('RailwayExport.Delete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as BoxTubeConstants from '@/class/cargo/model/parameters/BoxTubeConstants'
import { RailwayContainerOrder } from '@/class/model/booking/RailwayContainerOrder'
import { RailwayContainer } from '@/class/model/booking/RailwayContainer'
import { queryAvailableContainerData, createOrderForSell } from '@/api/railwayExport/railwayContainerOrder'

export default {
  name: 'SellingBoxDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    railwayList: { type: Array, required: true }
  },
  data() {
    const currencyList = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
    return {
      innerVisible: false,
      TYPE_NAMES,
      JUDGE_STATUS: BoxTubeConstants.JUDGE_STATUS,
      order: new RailwayContainerOrder().fillDefaultValue().getData(),
      buyLabel: '',
      buyAmountLabel: '',
      sellLabel: '',
      sellAmountLabel: '',
      currencyNow: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        rowHeight: 32,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
          for (const item of this.rowData) {
            item.isSelect = false
          }
          // 购箱总箱量
          this.calculationBox(false)
          // 成本总金额
          this.calculationAmountSum(false)
          // 卖出总箱量
          this.calculationBox(true)
          // 卖出总金额
          this.calculationAmountSum(true)
        },
        onSelectionChanged: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          for (const node of nodes) {
            node.data.isSelect = node.selected
          }
          // 卖出总箱量
          this.calculationBox(true)
          // 卖出总金额
          this.calculationAmountSum(true)
        },
        frameworkComponents: { CargoAgGridCommonInputEditor, CargoAgGridSelectEditor },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('RailwayExport.ContainerNo'),
          field: 'containerno',
          width: 180,
          editable: params => true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('RailwayExport.EQSize'),
          field: 'eqsize',
          width: 100
        }, {
          headerName: this.$t('RailwayExport.EQType'),
          field: 'eqtype',
          width: 100
        }, {
          headerName: this.$t('RailwayExport.CostUnitPrice'),
          field: 'unitPrice',
          width: 100
        }, {
          headerName: this.$t('RailwayExport.CostUnitPriceCurrencyCode'),
          field: 'currencyCode',
          width: 130
        }, {
          headerName: this.$t('RailwayExport.SellingUnitPrice'),
          field: 'sellAmount',
          width: 130,
          valueFormatter: params => {
            return params.value
          },
          editable: params => true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: params => {
            params.data.sellAmount = Number(params.data.sellAmount)
            // 卖出总金额
            this.calculationAmountSum(true)
          }
        }, {
          headerName: this.$t('RailwayExport.SellingUnitPriceCurrencyCode'),
          field: 'sellCurrencyCode',
          width: 130,
          editable: params => true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: false,
              clearable: false
            },
            options: currencyList,
            tagName: 'code',
            tagValue: 'code'
          },
          onCellValueChanged: params => {
            for (const item of this.rowData) {
              item.sellCurrencyCode = params.data.sellCurrencyCode
            }
            this.gridApi.refreshCells({ force: true })
            // 卖出总金额
            this.calculationAmountSum(true)
          }
        }, {
          headerName: this.$t('RailwayExport.Operation'),
          width: 90,
          cellRenderer: params => {
            const html = this.$refs.deleteBtnTemplate.$el.outerHTML
            const methodPath = this.documentManage.getPath('deleteHandler')
            return html.replace('void(0)', `${methodPath}('${params.data.uuid}')`)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      documentManage: new DocumentManage()
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          queryAvailableContainerData({ orderKeys: Array.from(this.railwayList, p => p.uuid).join(',') }).then(res => {
            for (const item of res.data) {
              item.sellAmount = item.unitPrice
              item.sellCurrencyCode = item.currencyCode
              this.currencyNow = item.currencyCode
            }
            this.rowData = res.data
          })
        }
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        new RailwayContainerOrder(this.order).reset()
        this.buyLabel = ''
        this.buyAmountLabel = ''
        this.sellLabel = ''
        this.sellAmountLabel = ''
        this.currencyNow = ''
        this.rowData = []
        this.$emit('resultFunction')
      }
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('deleteHandler', function(uuid) {
      self.deleteHandler(uuid)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 计算列表箱量
    calculationBox(isBuy) {
      const m = new Map()
      for (const item of this.rowData) {
        if (isBuy && item.isSelect) {
          const val = m.get(item.eqsize + item.eqtype)
          if (val) {
            m.set(item.eqsize + item.eqtype, val + 1)
          } else {
            m.set(item.eqsize + item.eqtype, 1)
          }
        } else if (!isBuy) {
          const val = m.get(item.eqsize + item.eqtype)
          if (val) {
            m.set(item.eqsize + item.eqtype, val + 1)
          } else {
            m.set(item.eqsize + item.eqtype, 1)
          }
        }
      }
      let text = ''
      for (const key of m.keys()) {
        if (text) {
          text += ','
        }
        text += key + '*' + m.get(key)
      }
      if (isBuy) {
        this.sellLabel = text
      } else {
        this.buyLabel = text
      }
    },
    // 计算列表金额
    calculationAmountSum(isBuy) {
      const m = new Map()
      for (const item of this.rowData) {
        if (isBuy && item.isSelect) {
          const val = m.get(item.sellCurrencyCode)
          if (val) {
            m.set(item.sellCurrencyCode, val + item.sellAmount)
          } else {
            m.set(item.sellCurrencyCode, item.sellAmount)
          }
        } else if (!isBuy) {
          const val = m.get(item.currencyCode)
          if (val) {
            m.set(item.currencyCode, val + item.unitPrice)
          } else {
            m.set(item.currencyCode, item.unitPrice)
          }
        }
      }
      let text = ''
      for (const key of m.keys()) {
        if (text) {
          text += ','
        }
        text += m.get(key).toFixed(2) + ' ' + key
      }
      if (isBuy) {
        this.sellAmountLabel = text
      } else {
        this.buyAmountLabel = text
      }
    },
    deleteHandler(uuid) {
      console.log('deleteHandler')
      const index = this.rowData.findIndex(p => p.uuid === uuid)
      const row = this.rowData[index]
      if (row.containerStatus === 2 || row.containerStatus === 3) {
        const t = row.containerStatus === 2 ? CommonState.getName(BoxTubeConstants.SOLD_OUT) : CommonState.getName(BoxTubeConstants.SOLD_OUT)
        this.$message.warning(this.$t('Message.NowContainer') + t + ',' + this.$t('Message.NotDelete'))
        return
      }
      this.rowData.splice(index, 1)
    },
    async successHandler() {
      if (this.rowData.length === 0) {
        this.$message.info(this.$t('Message.PleaseContainerData'))
        return
      }
      if (!this.currencyNow) {
        this.$message.info(this.$t('Message.PleaseSelectACurrency'))
        return
      }
      const selectRailWayContainer = []
      const saveList = []
      for (const item of this.rowData) {
        if (item.isSelect) {
          const newRc = new RailwayContainer().fillDefaultValue().getData()
          newRc.unitPrice = Number(item.sellAmount.toFixed(2))
          newRc.currencyCode = item.sellCurrencyCode
          newRc.eqsize = item.eqsize
          newRc.eqtype = item.eqtype
          newRc.containerno = item.containerno
          newRc.containerStatus = 3
          this.currencyNow = item.sellCurrencyCode
          selectRailWayContainer.push(item.uuid)
          saveList.push(newRc)
        }
      }
      if (saveList.length === 0) {
        this.$message.warning(this.$t('Message.PleaseCheckTheBoxToBeSold'))
        return
      }
      await cache.load(cacheName.OFFICE)
      const params = {}
      params.officeNo = cache.office.code
      params.orderType = 2
      params.buyerId = this.order.buyerId
      if (params.buyerId) {
        params.buyerName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.buyerId, 'chineseName')
      }
      params.ifSettlement = this.order.ifSettlement
      params.sellerDate = this.order.sellerDate
      params.settlementDate = this.order.settlementDate
      params.currencyCode = this.currencyNow
      params.selectList = selectRailWayContainer.join(',')
      await createOrderForSell(saveList, params)
      this.innerVisible = false
      this.$message.success(this.$t('Message.SaveSucceed'))
    },
    amountSum(list) {
      let amount = 0
      for (const item of this.rowData) {
        amount += item.unitPrice
      }
      return amount
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-inner .app-main-row {
  .input-w240 ::v-deep {
    .el-form-item__content {
      width: 240px;
      .el-input-number--mini {
        width: 100%;
      }
    }
  }
}
</style>
